export default {
    bgColor: 0xfff07f,
    primaryKey: "BGElmnts_Shl",
    secondaryKey: "BGElmnts_Cld2",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.setPosition(data.x, 1200);
        image.setScale(data.scaleX);
        let deltaX = (data.x/bg.scene.size.width);

        bg.scene.addTween(image, 2000, {y: data.y, delay: deltaX * 500, easeParams: [1, 1]}, "Elastic");
    },
    animateOut: (image, bg)=>{
        let deltaX = (image.x/bg.scene.size.width);
        bg.scene.addTween(image, 800, {y:-300, delay: deltaX * 1000}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnts_Shl",
            x: 875.4826501716061, y: 448.1425389755011,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Shl",
            x: 438.74577509820045, y: 431.0378619153675,
            angle: 0,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnts_Shl",
            x: 124.72882329144319, y: 400.24944320712694,
            angle: 0,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Shl",
            x: 61.44124287149774, y: 674.0824053452116,
            angle: 0,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Shl",
            x: 60.44124287149774, y: 170.902004454343,
            angle: 0,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnts_Shl",
            x: 297.5001500737319, y: 755.6057906458798,
            angle: 0,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Shl",
            x: 491.0600294927508, y: 140.4164810690423,
            angle: 0,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Shl",
            x: 296.63157551318693, y: 254.00445434298442,
            angle: 0,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Shl",
            x: 491.4809797857208, y: 644.2672605790646,
            angle: 0,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Shl",
            x: 762.0255777838678, y: 666.358574610245,
            angle: 0,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Shl",
            x: 636.8713672369469, y: 318.8574610244989,
            angle: 0,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Shl",
            x: 762.5912905035952, y: 163.3630289532294,
            angle: 0,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Shl",
            x: 266.1192107426692, y: 567.8619153674833,
            angle: 0,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Shl",
            x: 265.6982604496992, y: 62.72160356347439,
            angle: 0,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Shl",
            x: 644.1475551031594, y: 22.249443207126948,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shl",
            x: 1077.6235237312244, y: 168.34966592427617,
            angle: 0,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnts_Shl",
            x: 876.3512247321511, y: -49.43429844097996,
            angle: 0,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnts_Shl",
            x: 643.8580302496445, y: 524.2182628062361,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shl",
            x: 441.021962964413, y: -68.01336302895322,
            angle: 0,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Shl",
            x: 1083.3473358650122, y: 673.3184855233853,
            angle: 0,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Shl",
            x: 639.4637539312794, y: 821.9086859688197,
            angle: 0,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Shl",
            x: 906.8369155280639, y: 250.5835189309577,
            angle: 0,
            scaleX: 0.5499999999999996,
            scaleY: 0.5499999999999996
        },{
            key: "BGElmnts_Shl",
            x: 905.9816779548213, y: 756.7772828507796,
            angle: 0,
            scaleX: 0.5499999999999996,
            scaleY: 0.5499999999999996
        }
    ]
}